export default __webpack_public_path__ + "static/media/person_4.7beff6c5.jpg";